module.exports = __webpack_public_path__ + "static/media/BasierCircle-Regular.b1f5ae12.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Regular.woff2
// module id = 6539
// module chunks = 1